import { T } from "../Typography/T";

type StackedTextWeight = "normal" | "medium" | "semibold" | "bold";
type StackedTextColor = "default" | "brand" | "green" | "red";

interface StackedTextCellProps {
  primary: string | undefined;
  secondary?: string | undefined;
  primaryWeight?: StackedTextWeight;
  primaryColor?: StackedTextColor;
  primaryMono?: boolean;
}

export function StackedTextCell({
  primary,
  secondary,
  primaryWeight = "medium",
  primaryColor = "default",
  primaryMono,
}: StackedTextCellProps) {
  if (!primary) {
    return (
      <T color="faint" size="xs">
        {"\u2014"}
      </T>
    );
  }

  return (
    <div className="flex flex-col gap-0">
      <T
        weight={primaryWeight}
        color={primaryColor}
        {...(primaryMono ? { mono: primaryMono } : {})}
      >
        {primary}
      </T>
      {secondary && (
        <T size="xs" color="secondary">
          {secondary}
        </T>
      )}
    </div>
  );
}
